import React from "react";
import { Checkbox } from "antd";
import { cn } from "../../utils/cn";

const sizeMap = {
    sm: "scale-[0.9]",
    md: "scale-[1.1]",
    lg: "scale-[1.25]",
};

const CommonCheckbox = ({
    checked,
    onChange,
    children,
    disabled = false,
    size = "lg",
    className,
    ...props
}) => {
    return (
        <Checkbox
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            {...props}
            className={cn(
                "relative",

                sizeMap[size],

                /* base */
                "[&_.ant-checkbox-inner]:border-gray-300",
                "[&_.ant-checkbox-inner]:rounded-sm",

                /* hover (THIS is the fix) */
                "[&_.ant-checkbox:hover_.ant-checkbox-inner]:border-primary",

                /* checked */
                "[&_.ant-checkbox-checked_.ant-checkbox-inner]:bg-primary",
                "[&_.ant-checkbox-checked_.ant-checkbox-inner]:border-primary",

                className
            )}
        >
            {children}
        </Checkbox>
    );
};

export default CommonCheckbox;
